import SocketServer from './websocket.js'
import { getUser, getFollowMatch, getFollowLeague } from '../api/api.js';
//import protoRoot from '../../public/proto/proto.js';

SocketServer.Instance.connect();

export default {
	install(Vue, options) {
		//全局变量
		Vue.prototype.common = {
			//保存cookie
			setCookie: function (name, value) {
				var exdays = 30;
				var d = new Date();
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				var expires = "expires=" + d.toGMTString();
				document.cookie = name + "=" + value + "; " + expires + ";path=/";
			},

			//获取cookie
			getCookie: function (name) {
				var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

				if (arr = document.cookie.match(reg))

					return unescape(arr[2]);
				else
					return null;
			},

			//删除cookie
			delCookie: function (name) {
				var exp = new Date();
				exp.setTime(exp.getTime() - 1);

				var cval = this.getCookie(name);
				if (cval != null)
					document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
			},

			//localStorage存储数据
			infoStorage: function (name, value) {
				localStorage.setItem(name, value);
			},

			//localStorage获取数据
			getStorage: function (name) {
				localStorage.getItem(name);
			},

			//localStorage删除数据
			delStorage: function (name) {
				if (localStorage.getItem(name) != null) {
					localStorage.removeItem(name);
				}
			},

			//获取联赛logo地址
			leagueImgGet: function (id) {
				return 'https://data-img.sportsdt.net/football/matches/' + id + '.jpg';
			},

			//获取球队logo地址
			teamImgGet: function(id){
				return 'https://data-img.sportsdt.net/football/team/'+ id +'.jpg';
			},

			//获取球员logo地址
			playerImgGet: function(id){
				return 'https://data-img.sportsdt.net/football/player/'+ id +'.jpg';
			},

			// 获取国家logo地址
			countryImgGet: function(id){
				return 'https://data-img.sportsdt.net/football/mother_class_flag/'+ id +'.jpg';
			},

			// 资料库获取国家logo地址
			countryDataImgGet: function(id){
				return 'https://data-img.sportsdt.net/football/mother_class_flag/'+ id +'.jpg';
			},

			// 处理图片获取404
			imgError: function (e, type) {
				//console.log(e);
				var time = e.target.getAttribute('time');
				//console.log(time);
				if (parseInt(time) == 0) {
					var src = e.target.src;
					src = src.replace('.jpg', '.gif');
					e.target.src = src;
					e.target.setAttribute('time', '1');
				}
				else {
					var _src = '';
					if(type == 'team'){
						_src = require(`@/assets/images/team_default.png`)
					}
					if(type == 'country'){
						_src = require(`@/assets/images/flag_default.png`)
					}
					e.target.src = _src;
				}
			},

			// 没有国家处理
			noCountryBack(data, type){
				let _item = data, _type = type;
				
				if(typeof(_item['country']) != 'undefined'){
					if(_type == 'img'){
						return this.countryImgGet(_item['country']['id']);
					}

					if(_type == 'name'){
						if(typeof(_item['country']['name']) != 'undefined'){
							return _item['country']['name'] + ': ';
						}
						return '';
					}
				  
				}else{
					if(_type == 'img'){
						return this.countryImgGet(require(`@/assets/images/flag_default.png`));
					}

					if(_type == 'name'){
						return '';
					}
				}
				
			},

			//日期处理
			dateStr: function(str,formal){
				const date = new Date(str*1000);
				const YYYY = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? '0' + MM : MM;
				let dd = date.getDate();
				dd = dd < 10 ? '0' + dd : dd;
				let HH = date.getHours();
				HH = HH < 10 ? '0' + HH : HH;
				let mm = date.getMinutes();
				mm = mm < 10 ? '0' + mm : mm;
				let ss = date.getSeconds();
				ss = ss < 10 ? '0' + ss : ss;
				let ww = date.getDay();

				if(formal){
					var formalText = formal;
				}else{
					var formalText = 'YYYY-MM-dd';
				}
				return formalText.replace('YYYY',YYYY)
							 .replace('MM',MM)
							 .replace('dd',dd)
							 .replace('HH',HH)
							 .replace('mm',mm)
							 .replace('ss',ss)
							 .replace('ww',ww);
			},

			// 时区时间转换 tz-时区+08:00, svrtime-时间,返回分钟时间戳
			getDateByArray(tz, svrtime){
				let _svrtime = svrtime,
					_tz = tz,
					_year = this.dateStr(_svrtime, 'YYYY'),
					_month = this.dateStr(_svrtime, 'MM'),
					_day = this.dateStr(_svrtime, 'dd'),
					_hour = this.dateStr(_svrtime, 'HH'),
					_minute = this.dateStr(_svrtime, 'mm'),
					_second = this.dateStr(_svrtime, 'ss'),
					_tz_hour = 0,
					_tz_mintue = 0;
				
				if(_tz == '+08:00'){
				  _tz_hour = _tz_mintue = 0;
				}else{
				  let TZ_Hour = parseFloat(_tz.substring(0, 3));
				  let TZ_Minute = parseFloat(_tz.substring(4, 6));
				  _tz_mintue = TZ_Minute;
				  if (TZ_Hour < 0){
					_tz_hour = 0 - (8 - TZ_Hour);
					_tz_mintue = 0 - _tz_mintue;
				  }else{
					_tz_hour = TZ_Hour - 8;
				  }
				}
		
				return  Date.parse(new Date(Number(_year), Number(_month) - 1, Number(_day), Number(_hour)+_tz_hour, Number(_minute)+_tz_mintue, Number(_second), 0))/1000;
				//return  new Date(Number(_year), Number(_month) - 1, Number(_day), Number(_hour)+_tz_hour, Number(_minute)+_tz_mintue, Number(_second), 0);
			},

			//时间处理
			timeStr: function (str) {
				const date = new Date(str * 1000);
				const YYYY = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? '0' + MM : MM;
				let dd = date.getDate();
				dd = dd < 10 ? '0' + dd : dd;
				let HH = date.getHours();
				HH = HH < 10 ? '0' + HH : HH;
				let mm = date.getMinutes();
				mm = mm < 10 ? '0' + mm : mm;
				let ss = date.getSeconds();
				ss = ss < 10 ? '0' + ss : ss;

				let formal;
				formal = 'HH:mm';

				return formal.replace('HH', HH)
					.replace('mm', mm);
			},
			
			//递归合并
      		mergeObjects(obj1, obj2){
				function mergeObjects(obj1, obj2) {
					for (const key in obj2) {
						if (obj2.hasOwnProperty(key)) {
							if (typeof obj2[key] === 'object' && obj2[key] !== null && obj1[key]) {
								// 递归合并对象
								mergeObjects(obj1[key], obj2[key]);
							} else {
								// 直接替换键值
								obj1[key] = obj2[key];
							}
						}
					}
				}
				const result = { ...obj1 };
				mergeObjects(result, obj2);
				return result;
			},

			// 获取数据JSON转换
			jsonParse: function (data=null) {
				return JSON.parse(JSON.stringify(data));
			},

			// 是否已登录
			isLogin: function (obj) {
				let param = {
					userToken: '',
				}
		
				param = { ...param, ...obj }
		
				let _userInfo = this.getCookie('userInfo');
				
				if(typeof(_userInfo) != 'undefined' && _userInfo != null){
					_userInfo = JSON.parse(_userInfo);
					param.userToken = _userInfo.token;
					return new Promise((resolve, reject) => {
						return resolve(true);
					});
				}
		
				return getUser(param).then((res) => {
					let _res = res;
		
					if(_res.state == 403){ // 未登录
						//this.delCookie('userInfo');
						return false;
					}
		
					if(_res.state != 200){
						console.log(_res.msg);
						return;
					}
		
					let _userInfo = this.jsonParse(_res.data);
					_userInfo.nickname = escape(_userInfo.nickname).replace(/%/g, '-');
					this.setCookie('userInfo', JSON.stringify(_userInfo));
		
					return true;
		
				}).catch((res) => {
					console.error(res)
				})
				
			},

			// 获取地址参数
			GetQueryString: function (name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				var after = window.location.href.split("?")[1];
				if(typeof(window.location.href.split("?")[1]) == 'undefined'){
					return 'undefined';
				}
				var r = after.match(reg);
				console.log(r)
				if (r != null)
					return unescape(r[2]);
				return 'undefined';
			},

			// 欧赔赔率格式转换
			oddsFromChange: function(val, form){
				let _val = val, _form = form;



				if(_form == 1){ // EU
					return (_val*1).toFixed(2);
				}
				if(_form == 2){ // UK 以欧赔为基础，直接数值-1，得出的数字以分数显示。举例：主胜1.58，则1.59-1=0.58，显示为58/100，数字优化后，约为7/12
					
					let num = this.accMulValue(this.accSub(_val*1,1), 100), den = 100;
					if(num != 0){
						_val = this.getRaioStr(num, den);
					}else{
						_val = num + '/' + den;
					}
					return _val;
				}
				if(_form == 3){ // HK 以欧赔为标准，直接HK=欧赔-1，距离主胜1.59，HK=1.59-1=0.59
					_val = this.accSub(_val*1,1);
					return _val;
				}
				if(_form == 4){ // MA 以欧赔为基础，欧赔小于2时，MA=欧赔-1，举例：欧赔主胜1.78，MA=1.78-1=0.78，（解释：每投注1可以得到的盈利）; 以欧赔为基础，欧赔大于2时，MA=1/(欧赔-1)，举例：欧赔主胜3.25，MA=1/(3.25-1)=0.44，(解释：每盈利1必须投入0.44）
					if(_val < 2){
					  _val = this.accSub(_val*1,1);
					}
					if(_val > 2){
						let num = this.accSub(_val*1,1);
						if(num != 0){
							_val = this.accDiv(1,num).toFixed(2);
						}else{
							_val = 0;
						}
					}
					return _val;
				}
				if(_form == 5){ // US 以欧赔为基础，欧赔小于2时，US=-100/(欧赔-1），举例欧赔为客胜1.23，则US=-100/(1.23-1)=-434（解释：你要赢100，需要投入434本金）; 以欧赔为基础，欧赔大于2时，US=(欧赔-1）*100，举例欧赔为客胜3.23，则US=(3.23-1)*100=223（解释：你投入100，可以赢223）
					if(_val < 2){
						let num = this.accSub(_val*1,1);
						if(num != 0){
							_val = this.accDiv(-100,num).toFixed(0);
						}else{
							_val = 0;
						}
					}
					if(_val > 2){
					  _val = this.accMulValue(this.accSub(_val*1,1),100);
					}
					return _val;
				}
				if(_form == 6){ // IN 以欧赔为基础，欧赔小于2时，IN=-（欧赔-1），举例：欧赔主胜1.75，IN=-（1.75-1）=-0.75，（解释：负数表示投入1个单位能得到的盈利）; 以欧赔为基础，欧赔大于2时，IN=1/(欧赔-1)，举例：欧赔主胜3.25，MA=1/(3.25-1)=0.44，(解释：每盈利1必须投入0.44）
					if(_val < 2){
					  _val = -(this.accSub(_val*1,1));
					}
					if(_val > 2){
						let num = this.accSub(_val*1,1);
						if(num != 0){
							_val = this.accDiv(1, num).toFixed(2);
						}else{
							_val = 0;
						}
					}
					return _val;
				}
			},

			// 公约法
			getRaioStr: function(...restList){
				let arrList = [...restList];
				function gsy(m, n) {
				  return m % n == 0 ? n : gsy(n, m % n);
				}
				while (arrList.length > 1) {
				  arrList.push(gsy(arrList.pop(), arrList.pop()));
				}
				const num = arrList[0];
				const result = restList
				  .map((item, i, arr) => (arr[i] = item / num))
				  .join('/');
				return result;
			},

			// 比赛关注
			followMatch(obj){
				let _followParam = {
					matchId: 0,
					operation: 1,
					userToken: '',
					callback: null,
				};
				_followParam = { ..._followParam, ...obj };

				let _userInfo = this.getCookie('userInfo');
				
				if(typeof(_userInfo) != 'undefined' && _userInfo != null){
					_userInfo = JSON.parse(_userInfo);
					_followParam.userToken = _userInfo.token;
				}

				getFollowMatch(_followParam).then((res) => {
					//console.log(res)
					let _res = res;
					// if(_res.state != 200){
					//   console.log(_res.msg);
					//   return;
					// }

					if(_followParam.callback != null){ // 关注
						_followParam.callback(_res)
					}
		  
				}).catch((res) => {
					console.error(res)
				})
			},

			// 联赛关注
			followLeague(obj){
				let _followParam = {
					leagueId: 0,
					operation: 1,
					userToken: '',
					callback: null,
				};
				_followParam = { ..._followParam, ...obj };

				let _userInfo = this.getCookie('userInfo');
				
				if(typeof(_userInfo) != 'undefined' && _userInfo != null){
					_userInfo = JSON.parse(_userInfo);
					_followParam.userToken = _userInfo.token;
				}

				getFollowLeague(_followParam).then((res) => {
					console.log(res)
					let _res = res;
					// if(_res.state != 200){
					//   console.log(_res.msg);
					//   return;
					// }

					if(_followParam.callback != null){ // 关注
						_followParam.callback(_res)
					}
		  
				}).catch((res) => {
					console.error(res)
				})
			},


			//浮点运算加法 calculation(value1,value2) 
			addValue:function (value1,value2){
				if(value1=="")value1="0";
				if(value2=="")value2="0";
				value1=value1+'';
				value2=value2+'';
				var temp1=0;
				var temp2=0;
				if(value1.indexOf(".")!=-1)
				temp1=value1.length - value1.indexOf(".")-1;
				if(value2.indexOf(".")!=-1)
				temp2=value2.length - value2.indexOf(".")-1;
				
				var temp=0;
				
				if(temp1>temp2)
				temp = (parseFloat(value1)+parseFloat(value2)).toFixed(temp1);
				else
				temp = (parseFloat(value1)+parseFloat(value2)).toFixed(temp2);
				
				return temp;
				
			},
			//浮点运算乘法 accMulValue(value1,value2)
			accMulValue:function (num1, num2) {
					num1=num1+'';
					num2=num2+'';
					var m = 0,
							s1 = num1.toString(),
							s2 = num2.toString();
					try {
							m += s1.split(".")[1].length
					} catch (e) {};
					try {
							m += s2.split(".")[1].length
					} catch (e) {};
					return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
			},
			//浮点运算减法 accSub(value1,value2)
			accSub:function (num1, num2) {
					num1=num1+'';
					num2=num2+'';
					var r1, r2, m, n;
					try {
							r1 = num1.toString().split(".")[1].length;
					}
					catch (e) {
							r1 = 0;
					}
					try {
							r2 = num2.toString().split(".")[1].length;
					}
					catch (e) {
							r2 = 0;
					}
					m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
					n = (r1 >= r2) ? r1 : r2;
					return ((num1 * m - num2 * m) / m).toFixed(n);
			},
			//浮点运算除法 accDiv(value1,value2)
			accDiv:function (num1, num2) {
					num1=num1+'';
					num2=num2+'';
					var t1 = 0, t2 = 0, r1, r2;
					try {
							t1 = num1.toString().split(".")[1].length;
					}
					catch (e) {
					}
					try {
							t2 = num2.toString().split(".")[1].length;
					}
					catch (e) {
					}
					r1 = Number(num1.toString().replace(".", ""));
							r2 = Number(num2.toString().replace(".", ""));
							return (r1 / r2) * Math.pow(10, t2 - t1);
			},
			//防抖函数
			debounce(fn, wait) {
				let timer = null;

				return function () {
				let context = this,
					args = arguments;

				if (timer) {
					clearTimeout(timer);
					timer = null;
				}

				timer = setTimeout(() => {
					fn.apply(context, args);
				}, wait);
				};
			},
			//节流函数
			throttle(fn, delay) {
				let curTime = Date.now();

				return function () {
				let context = this,
					args = arguments,
					nowTime = Date.now();

				if (nowTime - curTime >= delay) {
					curTime = Date.now();
					return fn.apply(context, args);
				}
				};
			},

			// cookie昵称处理
			getUserName(nickname){
				let _nickname = nickname;
				_nickname = _nickname.replace(/-/g,'%');
            	_nickname = unescape(_nickname);

				return _nickname;
			},

			// 文本格式
			formalTitle(val){
				let title = val.toLocaleLowerCase()
        
				// let a = '1:2：3"4“5”6\'7？8' + "'s    9" + '?'
				let Exp=/[\:\：\“\”\"\‘\’\'\?\？\/]/g;
				title = title.replace(Exp,"")
				title = title.replace(/ /g, '-')

				return title;
			},

		},
		

		Vue.prototype.$socket = SocketServer.Instance;

		//Vue.prototype.$proto = protoRoot;
	}
}


// WEBPACK FOOTER //
// ./src/utils/common.js